import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import { Header } from './components/organisms/Header';
import { Footer } from './components/organisms/Footer';
import { MainLayout } from "./components/templates/MainLayout";
import { AppRoutes } from './routes';
import { GlobalStyle } from './styles/global';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import './utils/migrateData'; // Console için migrate fonksiyonu
import './utils/firebaseDebug'; // Firebase debug araçları
import { FloatingWhatsApp } from './components/common/FloatingWhatsapp';


// Admin components
import { AdminLogin } from './components/admin/AdminLogin';
import { AdminLayout } from './components/admin/AdminLayout';
import { ProtectedRoute } from './components/common/ProtectedRoute';

// Lazy load admin pages
const AdminDashboard = React.lazy(() => import('./components/admin/pages/AdminDashboard'));
const AdminProducts = React.lazy(() => import('./components/admin/pages/AdminProducts'));
const AdminCategories = React.lazy(() => import('./components/admin/pages/AdminCategories'));
const AdminSiteSettings = React.lazy(() => import('./components/admin/pages/AdminSiteSettings'));

function App() {
  return (
    <ThemeProvider>
    <HelmetProvider>
      <GlobalStyle />
      <AuthProvider>
        <Router>
          <Routes>
            {/* Admin rotaları */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }>
              <Route index element={<Navigate to="/admin/dashboard" replace />} />
              <Route path="dashboard" element={
                <React.Suspense fallback={<div>Yükleniyor...</div>}>
                  <AdminDashboard />
                </React.Suspense>
              } />
              <Route path="products" element={
                <React.Suspense fallback={<div>Yükleniyor...</div>}>
                  <AdminProducts />
                </React.Suspense>
              } />
              <Route path="categories" element={
                <React.Suspense fallback={<div>Yükleniyor...</div>}>
                  <AdminCategories />
                </React.Suspense>
              } />
               <Route path="site-settings" element={
                <React.Suspense fallback={<div>Yükleniyor...</div>}>
                  <AdminSiteSettings />
                </React.Suspense>
              } />
            </Route>

            {/* Public rotalar */}
            <Route path="/*" element={
              <>
                <Header />
                <MainLayout>
                  <AppRoutes />
                </MainLayout>
                <Footer />
                <FloatingWhatsApp />
              </>
            } />
          </Routes>
        </Router>
      </AuthProvider>
    </HelmetProvider>
    </ThemeProvider>
  );
}

export default App;